import { CameraStatusEnum } from '@api/enum';
import { ICameraInstallationAnalytics } from '@api/models/analytics.model';
import { Table } from '@hyperflake/react-ui-library';
import moment from 'moment';
import { Link } from 'react-router-dom';

interface ICameraInstallationListProps {
    isLoading: boolean;
    installations: ICameraInstallationAnalytics[];
}

const CameraInstallationList = ({ isLoading, installations }: ICameraInstallationListProps) => {
    const getStatusBadge = (status: CameraStatusEnum) => {
        const statusConfig = {
            [CameraStatusEnum.ENABLED]: { color: 'bg-success', label: 'ENABLED' },
            [CameraStatusEnum.DISBALED]: { color: 'bg-danger', label: 'DISABLED' },
            [CameraStatusEnum.CONCLUDED]: { color: 'bg-warning', label: 'CONCLUDED' },
            [CameraStatusEnum.CONCLUDING]: { color: 'bg-warning', label: 'CONCLUDING' },
            [CameraStatusEnum.DELETED]: { color: 'bg-danger', label: 'DELETED' },
            [CameraStatusEnum.RESTORING]: { color: 'bg-warning', label: 'RESTORING' },
            [CameraStatusEnum.ERROR]: { color: 'bg-danger', label: 'ERROR' },
        };

        const config = statusConfig[status];

        return (
            <span className={`px-2 py-1 rounded-full text-xs font-medium text-white ${config.color}`}>
                {config.label}
            </span>
        );
    };

    const getEnabledFeaturesCount = (features?: { [x: string]: any }) => {
        if (!features) return 0;
        return Object.values(features).filter(Boolean).length;
    };

    return (
        <Table
            className="mt-6"
            borderStyle="divider"
            hover={false}
            isLoading={isLoading}
            data={installations}
            columns={[
                { header: 'ID' },
                { header: 'Name' },
                { header: 'Client' },
                { header: 'Project' },
                // { header: 'Reseller' },
                // { header: 'Features' },
                { header: 'Status' },
                { header: 'Created At' },
                // { header: 'Updated At' },
            ]}
            renderRow={(row) => (
                <Table.Row key={row._id}>
                    <Table.Cell>
                        <Link
                            to={`/clients/${row.client._id}/projects/${row.project._id}/cameras/${row._id}`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row._id}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <div className="font-medium">{row.name}</div>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${row.client._id}/client-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row.client.name}
                        </Link>
                    </Table.Cell>

                    <Table.Cell>
                        <Link
                            to={`/clients/${row.client._id}/projects/${row.project._id}/project-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row.project.name}
                        </Link>
                    </Table.Cell>
                    <Table.Cell>{getStatusBadge(row.status)}</Table.Cell>

                    {/* <Table.Cell>
                        <Link
                            to={`/resellers/${row.reseller._id}/reseller-details`}
                            className="text-primary hover:underline"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {row.reseller.name}
                        </Link>
                    </Table.Cell> */}

                    {/* <Table.Cell>
                        <span className="text-sm text-gray-600">{getEnabledFeaturesCount(row.enabledFeatures)}</span>
                    </Table.Cell> */}

                    <Table.Cell>
                        <span className="text-sm">{moment(row.createdAt).format('HH:mm A - DD MMM YYYY')}</span>
                    </Table.Cell>
                </Table.Row>
            )}
        />
    );
};

export default CameraInstallationList;
